<template>
  <div class="wl-logistcs-intro">
    <div class="wl-breadcrumb-trail">
      <div class="crumbs-text">
        <i class="wl-icon-zhuye1"></i>
        <span>当前位置：</span>
        <span @click="goHome">首页</span>
        <span>></span>
        <span>物流X介绍</span>
      </div>
    </div>
    <div class="new-center-content">
      <div class="new-center-top">
        <h3 class="new-center-title">物流X介绍</h3>
        <div class="class-border"></div>
        <div class="new-center">LOGISTICS X INTRODUCTION</div>
        <div class="new-center-tab">
          <!-- <div
            class="new-center-dynamic"
            @click="tabSwitch(index,item.id)"
            :class="{'class-back':isTab == index}"
            v-for="(item,index) in knowList"
            :key="index"
          >{{item.title}}</div> -->
          <router-link :to="{name:'knowLogistics'}" class="new-center-dynamic">了解物流X</router-link>
          <router-link :to="{name:'authenticationCenter'}" class="new-center-dynamic">了解物流X</router-link>
          <router-link :to="{name:'textualResearch'}" class="new-center-dynamic">了解物流X</router-link>
        </div>
      </div>
    </div>
    <div class="wl-know-logistics">
       <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isTab: 0,
      defaultCover: "../../assets/images/new-course-cover.jpg",
      sample1: require("assets/images/wly.png"),
      sample2: require("assets/images/zlwls.png"),
      sample3: require("assets/images/zjwls.png"),
      sample4: require("assets/images/gjwls.png"),
      knowList: [],
      contentList: [],
      TeachingMaterial: []
    };
  },
  props:{
    tabIndex:{
      type:Number,
      default:0
    }
  },
  created() {
    this.isTab = Number(this.tabIndex);
    this.getIntroductionList();
  },
  computed: {
    association: function() {
      return this.$store.state.association;
    }
  },
  methods: {
    goHome() {
      this.$router.push({
        name: "xHome"
      });
    },
    tabSwitch(index, id) {
      this.isTab = index;
      this.getIntroduceNodeList(id);
      if(index == 2){
        this.getTeachingMaterialList();
      }
    },
    getIntroductionList() {
      var that = this;
      this.$http
        .post("/api/XOrg/Introduction/getIntroductionList", {
          // associationId: this.associationId
          associationId: this.association.Id
        })
        .then(rst => {
          if (rst.code == 1) {
            that.knowList = rst.introduce;
            this.getIntroduceNodeList(rst.introduce[that.isTab].id);
            if(that.index == 2){
              that.getTeachingMaterialList();
            }
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    getIntroduceNodeList(introduceId) {
      var that = this;
      this.$http
        .post("/api/XOrg/Introduction/getIntroduceNodeList", {
          introduceId: introduceId
        })
        .then(rst => {
          if (rst.code == 1) {
            that.contentList = rst.introduceNode;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    getTeachingMaterialList() {
      var that = this;
      this.$http
        .post("/api/XOrg/Introduction/getTeachingMaterialList", {
          associationId: this.association.Id
        })
        .then(rst => {
          if (rst.code == 1) {
            that.TeachingMaterial = rst.list;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    }
  }
};
</script>

<style>
.p_conent {
  font-size: 16px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 28px;
}
</style>
